export default __webpack_public_path__ + "img_220720_Warriors_at_Amazon_main_h_fullcolor_rgb_over_light.svg";